const { Uppy } = require('@uppy/core')
const German = require('@uppy/locales/lib/de_DE')
const Dashboard = require('@uppy/dashboard').default
const SparkMD5 = require('spark-md5')

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('[data-uppy]').forEach(element => {
    if (!element.hasAttribute('data-uppy-initialized')) {
      element.setAttribute('data-uppy-initialized', 'true')
      setupUppy(element)
    }
  })
})

document.addEventListener('turbo:load', () => {
  $('#modal').on('shown.bs.modal', function (event) {
    document.querySelectorAll('[data-uppy]').forEach(element => {
      if (!element.hasAttribute('data-uppy-initialized')) {
        element.setAttribute('data-uppy-initialized', 'true')
        setupUppy(element)
      }
    })
  })
})

document.addEventListener('cocoon:after-insert', function(event) {
  // After cocoon inserts, search the entire document for uninitialized uppy elements
  setTimeout(() => {
    document.querySelectorAll('[data-uppy]').forEach(element => {
      // Check if this element has already been initialized
      if (!element.hasAttribute('data-uppy-initialized')) {
        element.setAttribute('data-uppy-initialized', 'true')
        setupUppy(element)
      }
    })
  }, 100)
})

function getCsrfToken() {
  return document.querySelector("meta[name='csrf-token']").getAttribute("content")
}

function setupUppy(element) {
  let direct_upload_url = document.querySelector("meta[name='direct-upload-url']").getAttribute("content")
  let field_name = element.dataset.uppy
  let target = element.querySelector('.uppy-container')

  const uploadResponses = new Map()
  const checksumPromises = new Map()

  let uppy = new Uppy({
    autoProceed: true,
    allowMultipleUploads: false,
    locale: {
      ...German,
      strings: {
        ...German.strings,
        dropPasteImportBoth: 'Dateien können über Drag/Drop, Einfügen oder %{browse} hinzugefügt werden',
        dropPasteImportFiles: 'Dateien können über Drag/Drop, Einfügen oder %{browse} hinzugefügt werden',
        dropPasteBoth: 'Dateien können über Drag/Drop, Einfügen oder %{browse} hinzugefügt werden',
        dropPasteFiles: 'Dateien können über Drag/Drop, Einfügen oder %{browse} hinzugefügt werden',
        browse: 'per Suche',
        browseFiles: 'per Suche'
      }
    },
    restrictions: {
      maxFileSize: 10485760,
      allowedFileTypes: ['application/pdf']
    },
  })

  uppy.use(Dashboard, {
    inline: true,
    target: target,
    proudlyDisplayPoweredByUppy: false,
    height: 220,
    note: 'Pdf-Dateien, 10MB oder weniger',
    hideUploadButton: true,
    hideCancelButton: false,
    hideRetryButton: false,
    showProgressDetails: true,
    disablePageEnterLeave: false
  })

  function attachClickHandler() {
    const dashboardElement = target.querySelector('.uppy-Dashboard-AddFiles')
    if (dashboardElement) {
      dashboardElement.style.cursor = 'pointer'
      dashboardElement.removeEventListener('click', handleDashboardClick)
      dashboardElement.addEventListener('click', handleDashboardClick)
    }
  }

  function handleDashboardClick(e) {
    if (e.target.classList.contains('uppy-Dashboard-browse') || e.target.closest('.uppy-Dashboard-browse')) {
      return
    }
    const fileInput = target.querySelector('.uppy-Dashboard-input')
    if (fileInput) {
      fileInput.click()
    }
  }

  attachClickHandler()

  uppy.on('file-added', (file) => {
    const checksumPromise = new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const spark = new SparkMD5.ArrayBuffer()
        spark.append(e.target.result)
        const checksum = btoa(spark.end(true))
        uppy.setFileMeta(file.id, { checksum: checksum })
        resolve(checksum)
      }
      reader.readAsArrayBuffer(file.data)
    })

    checksumPromises.set(file.id, checksumPromise)
  })

  uppy.addUploader(async (fileIDs) => {
    const files = fileIDs.map(id => uppy.getFile(id))

    await Promise.all(files.map(async (file) => {
      try {
        await checksumPromises.get(file.id)

        const updatedFile = uppy.getFile(file.id)

        uppy.emit('upload-progress', updatedFile, {
          uploader: 'ActiveStorage',
          bytesUploaded: 0,
          bytesTotal: updatedFile.size
        })

        const blobResponse = await fetch(direct_upload_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': getCsrfToken()
          },
          body: JSON.stringify({
            blob: {
              filename: updatedFile.name,
              byte_size: updatedFile.size,
              checksum: updatedFile.meta.checksum,
              content_type: updatedFile.type || 'application/pdf'
            }
          })
        })

        if (!blobResponse.ok) {
          throw new Error('Failed to create blob on server')
        }

        const blobData = await blobResponse.json()

        uppy.emit('upload-progress', updatedFile, {
          uploader: 'ActiveStorage',
          bytesUploaded: Math.floor(updatedFile.size * 0.1),
          bytesTotal: updatedFile.size
        })

        const uploadResponse = await fetch(blobData.direct_upload.url, {
          method: 'PUT',
          headers: blobData.direct_upload.headers,
          body: updatedFile.data
        })

        if (!uploadResponse.ok) {
          throw new Error('Failed to upload file to storage')
        }

        uppy.emit('upload-progress', updatedFile, {
          uploader: 'ActiveStorage',
          bytesUploaded: updatedFile.size,
          bytesTotal: updatedFile.size
        })

        const responseData = {
          status: 200,
          body: {
            ...blobData,
            uploadURL: uploadResponse.url
          },
          signed_id: blobData.signed_id,
          pdf_meta: blobData.pdf_meta,
          uploadURL: uploadResponse.url
        }

        uploadResponses.set(file.id, responseData)

        uppy.setFileState(file.id, {
          response: responseData,
          uploadURL: uploadResponse.url,
          progress: {
            uploadComplete: true,
            uploadStarted: true
          }
        })
      } catch (error) {
        throw error
      }
    }))
  })

  uppy.on('complete', (result) => {
    element.querySelectorAll('[data-pending-upload]').forEach(element => element.parentNode.removeChild(element))

    result.successful.forEach(file => {
      const response = uploadResponses.get(file.id)
      if (response) {
        file.response = response
        appendUploadedFile(element, file, field_name)
        setPdfMeta(element, file).then(() => {
          setPreview(element, file)
        })
        if (element.querySelector('.document-actions')) {
          element.querySelector('.document-actions').remove()
        }
      }
      uppy.removeFile(file.id)
    })

    uploadResponses.clear()

    setTimeout(() => {
      attachClickHandler()
    }, 100)
  })
}

function setPdfMeta(element, file) {
  let direct_upload_url = document.querySelector("meta[name='direct-upload-url']").getAttribute("content")

  let containerElement = element.querySelector('[data-behavior="uppy-preview-container"]')
  let sizeElement = element.querySelector('[data-behavior="uppy-document-size"]')
  let submitButtonElement = document.querySelector('[data-behavior="uppy-submit"]')

  return fetch(`${direct_upload_url}/${file.response.signed_id}`)
    .then(response => response.json())
    .then(data => {
      if (data.size && sizeElement) {
        sizeElement.innerHTML = data.size
      }

      show(containerElement, submitButtonElement)
    })
    .catch(error => {
      show(containerElement, submitButtonElement)
    });

}

function appendUploadedFile(element, file, field_name) {
  const hiddenField = document.createElement('input')

  hiddenField.setAttribute('type', 'hidden')
  hiddenField.setAttribute('name', field_name)
  hiddenField.setAttribute('data-pending-upload', true)
  hiddenField.setAttribute('value', file.response.signed_id)

  element.appendChild(hiddenField)
}

function setPreview(element, file) {
  let preview = element.querySelector('[data-behavior="uppy-preview"]')
  if (preview && file.response && file.response.pdf_meta) {
    let pdfMeta = file.response.pdf_meta
    let src = pdfMeta.preview || "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSpj0DBTVsaja01_xWh37bcutvpd7rh7zEd528HD0d_l6A73osY"
    preview.src = src
  }
}

function show(...elements) {
  elements.forEach(element => {
    if (element) {
      element.classList.remove('d-none')
    }
  })

  const submitButton = document.querySelector('[data-behavior="uppy-submit"]')
  if (submitButton) {
    const buttonContainer = document.querySelector('[data-behavior="modal-button-container"]')
    if (buttonContainer && !buttonContainer.classList.contains('btn-group')) {
      buttonContainer.classList.add('btn-group')
    }
  }
}

$(document).on("click", ".btn-revise", function (event) {
  event.preventDefault()
  $(".chat__message-body-input").val($(this).data("body"))
  $(".chat__message-body-input").focus()
  $(this).closest(".chat__review-buttons").remove()
})
